import GoogleTagDataLayer from "app/components/GoogleTagDataLayer/GoogleTagDataLayer";
import type { EventType } from "app/types/eventType";
import React from "react";

type Props = {
  event: EventType;
  openModal: (...args: Array<any>) => any;
};
const AllPricesLinkOuterContainer: React.FC<Props> = ({ event, openModal }) => {
  return (
    <>
      {" "}
      <GoogleTagDataLayer
        googleTagClickId={"asianAdditionalMarkets"}
        dlvEventName={"DLV-Asian-Additional-Markets"}
      >
        <div className="all-prices-link-outer-container">
          {(event["numberOfAdditionalMarkets"] &&
            event["numberOfAdditionalMarkets"] !== 0) ||
          event.isActive ? (
            <div
              className="all-prices-link-inner-container"
              onClick={openModal}
            >
              {!event.isActive ? (
                <div className="all-prices-link-text">
                  +{event["numberOfAdditionalMarkets"]}
                </div>
              ) : (
                <span className="asian-event__markets-total__button">
                  <div className="asian-event__arrow" />
                </span>
              )}
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </GoogleTagDataLayer>
    </>
  );
};

export default AllPricesLinkOuterContainer;
